import { useEffect, useState } from "react";

const useFetch = (url) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    async function getData() {
      setIsLoading(() => true);
      const data = await fetch(url);
      const parsedData = await data.json();
      setData(() => parsedData.data);

      setIsLoading(() => false);
    }
    getData();
  }, [url]);

  return { data, isLoading };
};

export default useFetch;
